import React, { useState } from 'react';
import { Select, Input, Icon } from '@b-design/fusion';
import $i18n from '@/i18n';

import './index.less';

interface FilterItem {
  key: string;
  label: string;
}

interface TableFilterProps {
  filterKeys: FilterItem[];
  filterHandle: (param: any) => void;
  selectStyle?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
  hideFilterSelect?: boolean;
}

const TableFilter = ({
  filterKeys = [],
  filterHandle = () => {},
  selectStyle = {},
  inputStyle = {},
  hideFilterSelect = false,
}: TableFilterProps) => {
  const [filterKey, setFilterKey] = useState<string>(filterKeys?.[0]?.key);
  const [filterValue, setFilterValue] = useState<string>();

  const onSearch = () => {
    if (!filterKey) {
      return;
    }
    const filterParam = {};
    filterParam[filterKey] = filterValue || undefined;
    filterHandle && filterHandle(filterParam);
  };

  return (
    <div className="table-filter">
      {hideFilterSelect ? null : (
        <Select
          className="filter-select"
          style={selectStyle}
          value={filterKey}
          popupClassName="b-design-select"
          onChange={(v: string) => {
            setFilterKey(v);
            setFilterValue('');
          }}
        >
          {filterKeys.map((val) => {
            return (
              <Select.Option value={val.key} key={val.key}>
                {val.label}
              </Select.Option>
            );
          })}
        </Select>
      )}
      <Input
        className="filter-input"
        style={inputStyle}
        placeholder={$i18n.get({ id: 'aopf.pages.miniapp.input.Search', dm: '搜索...' })}
        value={filterValue}
        onChange={(v) => setFilterValue(v)}
        innerBefore={<Icon type="search" style={{ marginTop: 5 }} />}
        onPressEnter={onSearch}
      />
    </div>
  );
};

export default TableFilter;
